import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default function Security(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'MYFHE__FHEPRODUCT_SET_SECURITIES':
            return core.setSecurities(state, action.Securities);
        case 'MYFHE__FHEPRODUCT_UPDATE_SECURITIES':
            return core.updateSecurities(state, action.Securities);
        case 'MYFHE__FHEPRODUCT_SET_SECURITY_DETAILS':
            return core.setSecurityDetails(state, action.SecurityId, action.SecurityDetails);
        case 'MYFHE__FHEPRODUCT_UPDATE_SECURITY_STATUS':
            return core.updateSecurityStatus(state, action.productIdentifier, action.status);
        case 'MYFHE__FHEPRODUCT_MASTER_SWITCH_SECURITY':
            return core.switchSecurityMaster(state, action.productIdentifier, action.masterId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_SECURITY':
            return core.dissociateUserFromSecurity(state, action.productIdentifier, action.userId);
        case 'MYFHE__FHEPRODUCT_DISSOCIATE_USER_AND_SWITCH_MASTER_SECURITY':
            return core.dissociateUserFromSecurityAndSwitchMaster(state, action.productIdentifier, action.userId, action.masterId);
    }

    return state;
}



// WEBPACK FOOTER //
// ./environments/myfhe/data/Security/reducer.js